import { Button } from "antd";
import { useRef, useState } from "react";
import { ROUTES } from "Features/Routes/routeConstants";
import { useNavigate } from "react-router-dom";

export const DemoVideo = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    videoRef.current.play();
    setPlaying(true);
  };

  return (
    <div className="relative shadow-lg bg-white p-4 rounded-lg h-full">
      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          🎥 See Achiever in Action
        </h3>
        <p className="text-base text-gray-600">
          Watch how OneGrad helps students achieve their dream college
          admissions
        </p>
      </div>

      {/* VIDEO */}
      <div className="relative w-full">
        <video
          ref={videoRef}
          className="w-full rounded-lg shadow-lg"
          controls={playing}
        >
          <source src="/videos/financeLoan.mov" />
        </video>

        {/* Overlay BEFORE playing */}
        {!playing && (
          <div
            onClick={handlePlay}
            className="absolute inset-0 flex flex-col items-center justify-center 
                       bg-slate-900 bg-opacity-90 rounded-lg cursor-pointer transition"
          >
            {/* Big Play Button */}
            <div className="bg-white bg-opacity-90 p-6 rounded-full shadow-xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-gray-900"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>

            {/* Caption below button */}
            <div className="mt-4 text-white text-lg font-semibold">
              Watch Achiever in Action
            </div>
          </div>
        )}
      </div>

      <div>
        <Button
          type="primary"
          size="large"
          className="mt-4 text-lg font-medium h-fit py-2 px-4"
          onClick={() => {
            navigate(ROUTES.PRICING);
          }}
        >
          Unlock Achiever
        </Button>
      </div>
    </div>
  );
};
